<template>
  <v-dialog v-model="dialog" width="400">
    <v-card>
      <v-card-title class="headline">
        Instalar Certificado QZ Tray
      </v-card-title>
      <v-card-text>
        <video
          width="100%"
          controls
          src="@/assets/video/qz/certificate-install.webm"
          autoplay
          muted
          loop
          playsinline
        ></video>

        <!-- Faca um passo a passo para instalar o certificado
         Para instalar o usuário precisa baixar o certificado que deve ter exatamente o nome 'override.crt'
         ele deve colocar esse certificado na pasta raiz do QZ Tray, que normalmente fica em: C:\program Files\QZ Tray.
         O video mostra como chegar na pasta de instalação utilizando os menus do qz tray.
          Depois de colocar o certificado na pasta raiz do QZ Tray, o usuário deve reiniciar o QZ Tray.
          Depois de reiniciar o QZ Tray, o usuário pode testar a conexção para ver se o certificado foi instalado corretamente. Quando ele testar a conexão, o QZ Tray não deve pedir para aprovar o certificado manualmente.
         -->
        <p>
          Para instalar o certificado de segurança do QZ Tray, siga os passos
          abaixo:
        </p>
        <ol>
          <li>Feche o QZ Tray se ele estiver em execução.<br /></li>
          <li>
            Baixe o certificado clicando no botão abaixo.<br />
            <v-btn
              :disabled="isConnected"
              color="primary"
              class="mb-2"
              small
              depressed
              @click="downloadCertificate"
            >
              Baixar Certificado
            </v-btn>
          </li>
          <li>
            Coloque o arquivo <code><strong>override.crt</strong></code> na
            pasta raiz do QZ Tray. <br />
            <small>
              Normalmente, essa pasta fica em
              <code>C:\Program Files\QZ Tray</code>.
            </small>
          </li>
          <li>Reinicie o QZ Tray para aplicar as mudanças.</li>
          <li>
            Após reiniciar, volte ao sistema e teste a conexão com o QZ Tray. Se
            o certificado foi instalado corretamente, você não precisará
            aprová-lo manualmente.
            <br />
            <v-btn
              color="primary"
              class="ml-2"
              small
              depressed
              @click="testConnection"
              :loading="testing"
            >
              Testar Conexão
            </v-btn>
            <v-icon v-if="!testing && success" color="success" class="ml-2"
              >mdi-check-circle</v-icon
            >
          </li>
        </ol>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" text @click="dialog = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { STORAGE_KEY, storage } from "@/utils/qz-tray/manageCertificates";
export default {
  name: "QZCertificateInstall",
  data() {
    return {
      dialog: false,
      testing: false,
      success: false,
    };
  },
  props: {
    qz: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async testConnection() {
      try {
        this.testing = true;
        this.success = false;

        if (!this.qz.websocket.isActive()) {
          await this.qz.connect();
        }

        await this.qz.printers.getDefault();
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 5000);
      } catch (err) {
        console.error("Erro ao testar conexão com QZ Tray:", err);
        this.success = false;
      } finally {
        this.testing = false;
      }
    },
    async downloadCertificate() {
      try {
        const sessionCertificates = storage.getItem(STORAGE_KEY);
        if (!sessionCertificates)
          throw new Error(
            "Não foi possivel encontrar o certificado na sessão."
          );
        const certificates = JSON.parse(sessionCertificates);
        const pem = certificates.pem;
        this.downloadFile(pem, "override.crt", "application/x-x509-ca-cert");
      } catch (err) {
        console.error("Erro ao baixar certificado:", err);
      }
    },
    async downloadFile(content, fileName, contentType) {
      try {
        const file = new Blob([content], { type: contentType });

        // // Verifica se o navegador é compativel com a api Files
        // if (window.showDirectoryPicker) {
        //   const fileHandle = await window.showDirectoryPicker({
        //     mode: "readwrite",
        //   });
        //   const writable = await fileHandle.createWritable();
        //   await writable.write(content);
        //   await writable.close();
        //   return;
        // }

        const a = document.createElement("a");

        a.href = URL.createObjectURL(file);
        a.download = fileName;

        // Adiciona o link ao corpo (necessário para alguns navegadores)
        document.body.appendChild(a);

        // Dispara o clique
        a.click();

        // Limpa o link
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(a.href);
        }, 0);
      } catch (err) {
        console.error("Falha ao iniciar download:", err);
      }
    },
  },
  computed: {
    ...mapGetters("qz", ["isConnected"]),
  },
  mounted() {
    this.$parent.$on("certificateInstallInstructions", () => {
      this.dialog = true;
    });
  },
};
</script>
